import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId", "description", "isChecked", "isDisabled", "onChange", "children"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { useRef } from 'react';
import styled from 'styled-components';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Box from 'components/Box';
import Text from 'components/Text';
import Switch from 'components/Switch';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import { BASIC } from 'styles/spacingPresets';
var Grid = styled.div.withConfig({
  displayName: "TitleCardWithSwitch__Grid",
  componentId: "sc-1gp4d1n-0"
})(["display:grid;grid-template-rows:", ";transition:grid-template-rows 0.5s ease-in-out;"], function (p) {
  return p.isVisible ? '1fr' : '0fr';
});
export function TitleCardWithSwitch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    description = _ref.description,
    isChecked = _ref.isChecked,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onChange = _ref.onChange,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var id = useUniqueId();
  var switchRef = useRef(null);
  var descriptionId = description ? "".concat(id, "-desc") : undefined;
  var headingId = titleId !== null && titleId !== void 0 ? titleId : "".concat(id, "-heading");

  // Allow clicking the whole card to enable the switch.
  // Disabling requires clicking the switch directly.
  function handleCardClick(_ref2) {
    var target = _ref2.target;
    if (!isChecked && switchRef.current !== null && target instanceof Node && switchRef.current !== target && !switchRef.current.contains(target)) {
      switchRef.current.click();
    }
  }
  return /*#__PURE__*/React.createElement(Card, _extends({
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS
  }, otherProps, {
    onClick: handleCardClick,
    cursor: isChecked ? undefined : 'pointer'
  }), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    pr: "m"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    id: headingId
  }, title), Boolean(description) && /*#__PURE__*/React.createElement(Text, {
    id: descriptionId,
    as: "p",
    size: "s",
    mt: "xxs"
  }, description)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Switch, {
    id: id,
    ref: switchRef,
    disabled: isDisabled,
    checked: isChecked,
    onChange: onChange,
    "aria-labelledby": headingId,
    "aria-describedby": descriptionId
  }))), /*#__PURE__*/React.createElement(Grid, {
    "aria-hidden": !isChecked,
    isVisible: isChecked
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Divider, {
    my: "m"
  }), children)));
}